import { createContext, useState, useContext, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useMarketToggle } from "./MarketContext";
const ResultContext = createContext();

// export const ResultProvider = ({ children }) => {
//   const [stockData, setStockData] = useState(null);
//   const [intraday,setIntraday]=useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   //   const BASE_URL = "http://localhost:8000";
//   const BASE_URL = process.env.REACT_APP_API_BASE_URL;
//   const navigate = useNavigate();
//   const { market, toggleMarket } = useMarket();
//   const isNse = market === "india";
//   const searchStock = async (searchText = "Infosys") => {
//     if (!searchText.trim()) return;
//     console.log("IsNse", isNse);

//     try {
//       setLoading(true);
//       setError(null);
//       if (isNse) {
//         try {
//           const response = await axios.get(`${BASE_URL}/api/stockdata`, {
//             params: { name: searchText.trim() },
//           });

//           //   const matches = response.data.bestMatches || [];

//           setStockData(response.data);
//         } catch (err) {
//           console.error("Error fetching global stock results:", err.message);
//           setError("Failed to fetch global stock results. Please try again.");
//           return;
//         } finally {
//           setLoading(false);
//         }
//         const company=stockData?.companyName;
//         const stockIdObject =
//           stockData.data?.companyProfile?.peerCompanyList?.find(
//             (stock) =>
//               stock.companyName?.toLowerCase() === company?.toLowerCase()
//           );
//         const stockIdNse = stockIdObject?.tickerId;
//         console.log("StockIdNSE", stockIdNse);
//         try{
//          const response=await axios.get(`${BASE_URL}/api/intraday`,{
//             stock_id: stockIdNse,
//          });
//          setIntraday(response.data);
//          console.log("Intraday",response.data);

//         }catch(err){
//             console.log("Error is:-",err);
//         }
//       } else {
//       }
//     } catch (err) {
//       console.log("Error", err);
//     }
//     const intradayIndicators = intraday?.indicators;
//     const histoMin = intraday?.historicalData;
//   console.log("histoMin", histoMin);
//   const macdChartDataMin =
//     Array.isArray(intradayIndicators?.macd) &&
//     intradayIndicators?.macd.map((row, i) => ({
//       date:
//         histoMin?.[i + (histoMin?.length - intradayIndicators?.macd?.length)]
//           ?.date || i + 1,
//       MACD: row.MACD ?? 0,
//       signal: row.signal ?? 0,
//       histogram: row.histogram ?? 0,
//     }));
//     console.log("MacdCharatData",macdChartDataMin);
//     const getInterpretation = (indicators) => {
//     // --- SAFETY CHECK ---
//     if (
//       !indicators ||
//       !Array.isArray(indicators.macd) ||
//       !Array.isArray(indicators.rsi) ||
//       indicators.macd.length === 0 ||
//       indicators.rsi.length === 0
//     ) {
//       return {
//         result: "⚠️ Insufficient data",
//         color: "#e6eef3",
//         prediction: "Neutral",
//       }; // gray
//     }

//     // --- GET LATEST VALUES ---
//     const latestMACD = indicators.macd.slice(-1)[0];
//     const latestRSI = indicators.rsi.slice(-1)[0];

//     // --- DETERMINE RSI STATUS ---
//     let rsiStatus = "Neutral";
//     if (latestRSI >= 70) rsiStatus = "Overbought";
//     else if (latestRSI <= 30) rsiStatus = "Oversold";
//     else if (latestRSI > 50) rsiStatus = "Neutral-Bullish";
//     else rsiStatus = "Neutral-Bearish";

//     // --- DETERMINE MACD STATUS ---
//     let macdStatus = "Neutral";
//     if (latestMACD.MACD > latestMACD.signal && latestMACD.histogram > 0) {
//       macdStatus = "Bullish";
//     } else if (
//       latestMACD.MACD < latestMACD.signal &&
//       latestMACD.histogram < 0
//     ) {
//       macdStatus = "Bearish";
//     }

//     if (
//       (rsiStatus.includes("Bullish") || latestRSI > 55) &&
//       macdStatus === "Bullish"
//     ) {
//       return {
//         result: "📈 Strong Bullish Momentum (RSI & MACD aligned)",
//         color: "#2fd18a",
//         prediction: "Buy", // green
//       };
//     }

//     if (
//       (rsiStatus.includes("Bearish") || latestRSI < 45) &&
//       macdStatus === "Bearish"
//     ) {
//       return {
//         result: "📉 Strong Bearish Momentum (RSI & MACD aligned)",
//         color: "#f87171",
//         prediction: "Sell", // red
//       };
//     }

//     // --- DIVERGENCE CASES ---
//     // RSI uptrend but MACD downtrend or vice versa
//     if (
//       (latestRSI > 50 &&
//         latestMACD.MACD < latestMACD.signal &&
//         latestMACD.histogram < 0) ||
//       (latestRSI < 50 &&
//         latestMACD.MACD > latestMACD.signal &&
//         latestMACD.histogram > 0)
//     ) {
//       return {
//         result:
//           "⚠️ Divergence detected (RSI and MACD conflict) - Possible reversal ahead",
//         color: "#fbbf24",
//         prediction: "Neutral", // yellow
//       };
//     }

//     // --- EXTREME CONDITIONS ---
//     if (rsiStatus === "Overbought" && macdStatus === "Bullish") {
//       return {
//         result: "🚨 Overbought! Bullish but nearing exhaustion",
//         color: "#f59e0b",
//         prediction: "Sell", // amber-orange
//       };
//     }

//     if (rsiStatus === "Oversold" && macdStatus === "Bearish") {
//       return {
//         result: "🩸 Oversold! Bearish but near potential rebound zone",
//         color: "#60a5fa",
//         prediction: "Buy", // blue
//       };
//     }

//     // --- NEUTRAL / SIDEWAYS ---
//     return {
//       result: "⚖️ Neutral / Sideways Market (No strong signal)",
//       color: "#9ca3af",
//       prediction: "Neutral", // grayish neutral
//     };
//   };

//   const { result, color, prediction } = getInterpretation(intradayIndicators);

//     return (
//       <ResultContext.Provider value={{ stockData }}>
//         {children}
//       </ResultContext.Provider>
//     );
//   };
//   console.log("StockData", stockData);
// };

export const ResultProvider = ({ children }) => {
  const [stockData, setStockData] = useState(null);
  const [intraday, setIntraday] = useState(null);
  const [prediction, setPrediction] = useState(null);
  const [color, setColor] = useState(null);
  const [searchText, setSearchText] = useState(""); // ✅ added here
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  const { market } = useMarketToggle();
  const isNse = market === "india";

  const searchStock = async (query) => {
    if (!query?.trim()) return;

    setSearchText(query); // ✅ store query globally
    console.log("Searching for:", query);

    try {
      setLoading(true);
      setError(null);

      if (isNse) {
        const response = await axios.get(`${BASE_URL}/api/stockdata`, {
          params: { name: query.trim() },
        });

        const stockResponse = response.data;
        setStockData(stockResponse);
        console.log("stockResponse", stockResponse);

        const company = stockResponse?.companyProfile?.companyName;
        const peerList = stockResponse?.companyProfile?.peerCompanyList || [];

        const stockIdObject = peerList.find(
          (s) => s.companyName?.toLowerCase() === company?.toLowerCase(),
        );
        const stockIdNse = stockIdObject?.tickerId;

        if (!stockIdNse) {
          setError("No intraday data available for this stock.");
          return;
        }

        // Fetch intraday data
        const intradayResponse = await axios.post(`${BASE_URL}/api/intraday`, {
          stock_id: stockIdNse,
        });

        setIntraday(intradayResponse.data);

        const indicators = intradayResponse.data?.indicators;
        const interpretation = getInterpretation(indicators);
        setPrediction(interpretation.prediction);
        setColor(interpretation.color);
      } else {
      }
    } catch (err) {
      console.error("Error fetching stock:", err.message);
      setError("Failed to fetch stock data.");
    } finally {
      setLoading(false);
    }
  };

  // ✅ your interpretation logic (same as before)
  const getInterpretation = (indicators) => {
    if (
      !indicators ||
      !Array.isArray(indicators.macd) ||
      !Array.isArray(indicators.rsi) ||
      indicators.macd.length === 0 ||
      indicators.rsi.length === 0
    ) {
      return {
        result: "⚠️ Insufficient data",
        color: "#e6eef3",
        prediction: "Neutral",
      };
    }

    const latestMACD = indicators.macd.slice(-1)[0];
    const latestRSI = indicators.rsi.slice(-1)[0];
    let rsiStatus =
      latestRSI >= 70
        ? "Overbought"
        : latestRSI <= 30
          ? "Oversold"
          : latestRSI > 50
            ? "Neutral-Bullish"
            : "Neutral-Bearish";
    let macdStatus =
      latestMACD.MACD > latestMACD.signal && latestMACD.histogram > 0
        ? "Bullish"
        : latestMACD.MACD < latestMACD.signal && latestMACD.histogram < 0
          ? "Bearish"
          : "Neutral";

    if (
      (rsiStatus.includes("Bullish") || latestRSI > 55) &&
      macdStatus === "Bullish"
    )
      return { result: "📈 Bullish", color: "#2fd18a", prediction: "Buy" };

    if (
      (rsiStatus.includes("Bearish") || latestRSI < 45) &&
      macdStatus === "Bearish"
    )
      return { result: "📉 Bearish", color: "#f87171", prediction: "Sell" };

    return { result: "⚖️ Neutral", color: "#9ca3af", prediction: "Neutral" };
  };

  return (
    <ResultContext.Provider
      value={{
        prediction,
        color,
        searchStock,
      }}
    >
      {children}
    </ResultContext.Provider>
  );
};

export const useResult = () => useContext(ResultContext);
